import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import notificationState from "../../states/notificationState";
import DeleteRecordButton from "../input/DeleteRecordButton";
import CustomRecordButton from './../input/CustomRecordButton';
import {debounce} from "lodash";
import AutoForm from "../form/functional/AutoForm";
import layoutConf from "../../config/layoutConf";
import BasicCrudScreenHeaderLayout from "../screenTypes/layout/BasicCrudScreenHeaderLayout";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";
import { useTranslation } from "react-i18next";
import AutoFormViewLayout from "../form/layout/AutoFormViewLayout";

const id = "CardInfo";

function CardInfo ( props ) {

    const { t } = useTranslation();

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [selectGrid, setSelectGrid] = useState();
    const [height, setHeight] = useState(0);

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        window.addEventListener('resize', handleResize);
        handleResize();

        async function schemaSetting() {
            let schema = await getSchema("CardInfo");
            if(mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();
        return (() => {
            mounted = false;
            window.removeEventListener('resize', handleResize);
        });
    }, []);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler(debounce((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {

                    setSelectGrid(grid.selectedItems[0]);
                } else {
                    setSelectGrid(undefined);
                };
            }, 10));

            grid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setSelectGrid(grid.selectedItems[0]);
                } else {
                    setSelectGrid(undefined);
                };
            }, 10));
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        grid.selectionMode = "Row";
        setGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };
    
    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    return (
        <div style={{ height: height }} >
            <ReflexContainer orientation="vertical">
            <ReflexElement flex={0.25}>
                <BasicCrudScreenType 
                    id={id} 
                    table="CardInfo" 
                    view="VwCardInfo"
                    headerTitle = {t("term.cardInfo")}
                    onApiInitialized={onApiInitialized}
                    onInitialized={onInitialized}
                    noCreate
                    noEdit
                    noDelete
                    noExcel
                />

            </ReflexElement>
            <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />
            <ReflexElement flex={0.75}>
                <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">
                    <BasicCrudActionsLayout>
                        <ToolbarFlexSpacer xs />
                        <BasicCrudScreenActionItemLayout>
                            <CustomRecordButton
                                    id={id}
                                    grid={grid}
                                    refresh={api}
                                    schema={schema}
                                    onSuccess={onSuccess}
                                    disabled = {Number(selectGrid?.isExist)}
                                    mode="edit"
                                    title="create"
                                    buttonFullName="buttonName.create"
                                    isFormData
                                />
                        </BasicCrudScreenActionItemLayout>
                        <BasicCrudScreenActionItemLayout>
                            <CustomRecordButton 
                                    id={id}
                                    grid={grid}
                                    refresh={api}
                                    schema={schema}
                                    isFormData
                                    disabled = {!Number(selectGrid?.isExist)}
                                    mode="edit"
                                    method="put"
                                    title="update"
                                    buttonFullName="buttonName.update"
                                    onSuccess={notifySuccess}
                                    modifyUrlCallback = {(url)=> url + "/" + selectGrid.materialCode + "/" + selectGrid.materialCodeVer }
                                    modifyFormDataCallback ={(formData, name, )=>{
                                        if(name === 'inlay') {
                                            formData.bumpingType = null;
                                            formData.spotType = null;
                                        }
                                    }}
                            />
                        </BasicCrudScreenActionItemLayout>
                        <BasicCrudScreenActionItemLayout>
                            <DeleteRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={api}
                                color="secondary"
                                onSuccess={onSuccess}
                                onFailure={onFailure}
                                onPartialFailure={onNotifyWarning}
                                disabled = {!Number(selectGrid?.isExist)}
                            />
                        </BasicCrudScreenActionItemLayout>
                    </BasicCrudActionsLayout>
                    <AutoFormViewLayout>
                        <AutoForm
                            schema = {schema}
                            mode = "edit"
                            initialData = {{...selectGrid}}
                            onChange = {()=>{}}
                            checkDisabledCallback = {(_, column)=>{
                                column.required = false;
                                return true;
                            }}
                        />
                    </AutoFormViewLayout>
                </BasicCrudScreenHeaderLayout>
            </ReflexElement>
            </ReflexContainer>
            
        </div>
    )

}

export default CardInfo 

